import Backdrop from '@mui/material/Backdrop'
import CircularProgress from '@mui/material/CircularProgress'
import { FC } from 'react'

interface Props {
  isLoading: boolean
  withBackdrop?: boolean
}

const PageSpinner: FC<Props> = ({ isLoading = false, withBackdrop = true }: Props) => (
  <Backdrop open={isLoading} invisible={!withBackdrop} sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
    <CircularProgress />
  </Backdrop>
)

export default PageSpinner
